<section class="w-full h-dvh flex justify-center items-center">
    <article class="w-11/12 max-w-2xs">
        <div class="flex justify-center items-center">
            <img src="" alt="" />
        </div>
    </article>
</section>
